console.log('Engine ready 👩🏻‍🔬⚗️🧪🥼');

//ANIMATIONS

//airport on dom ready

var splitAirport = new SplitText('.animation-title__airport', {
    position: "relative",
    type: "lines",
});

gsap.set('.animation-title__airport',{
  overflow: 'hidden',
})

gsap.set(splitAirport.lines,{
    y: 100,
    opacity: 0
})
gsap.to(splitAirport.lines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: 0.1,
    delay: 0.1
});

//airport on scroll

let splitAirportScroll = document.querySelectorAll('.animation-title__airport-scroll');

if (splitAirportScroll.length > 0) {
  splitAirportScroll.forEach((element) => {
  
    var split = new SplitText(element, {
      position: "relative",
      type: "lines",
    });
  
    gsap.set(element, {
      overflow: 'hidden',
    });

    gsap.set(split.lines, {
      autoAlpha: 0,
      y: 100
    });
  
    gsap.to(split.lines, {
      duration: 0.8,
      y: 0,
      autoAlpha: 1,
      stagger: 0.1,
      delay: 0.1,
      scrollTrigger: {
        trigger: element, 
        start: 'top 90%', 
        end: 'bottom 50%', 
        toggleActions: 'play none none none', 
        markers: false 
      }
    });
  
  });
}


//animation fade appear scroll

let fadeAppear = document.querySelectorAll('.animation-fade__appear-scroll');
if (fadeAppear.length > 0) {
  fadeAppear.forEach(element => {
    let wrap = element.querySelector('.wrap');
    gsap.set(wrap, {
      y : "20%",
      opacity: 0
    })
    gsap.
      timeline({
        scrollTrigger: {
          trigger: element, 
          start: 'top 80%', 
          end: 'bottom 50%', 
          toggleActions: 'play none none none', 
          markers: false,
          // scrub: true
        }
      })
      .to(wrap, {
        duration: 1.5,
        y: "0%",
      },0.2)
      .to(wrap, {
        duration: 1,
        opacity: 1,
      },0.2)
  });
}

//animation fade enlarge scroll
let fadeEnlarge = document.querySelectorAll('.animation-fade__enlarge-scroll');
if (fadeEnlarge.length > 0) {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    fadeEnlarge.forEach(element => {

      let animEl = element.querySelector('.animation-el');
      let description = element.querySelector('.descriptionarea');
      
      if (animEl) {
        gsap.set(animEl, {
          y: "50%",
          opacity: 0,
          padding: "0 25%"
        })
        gsap.set(description, {
          opacity: 0,
        })
  
        gsap.
          timeline({
            scrollTrigger: {
              trigger: element,
              start: 'top bottom',
              end: '50% 50%',
              markers: false,
              once: true
            }
          })
          .to(animEl, {
            duration: 0.75,
            y: "0%",
          }, 0)
          .to(animEl, {
            duration: 0.75,
            opacity: 1,
          }, 0)
          .to(animEl, {
            duration: 0.75,
            padding: "0 0%"
          }, 0.25)
          .to(description, {
            duration: 0.75,
            opacity: 1
          }, 0.5)
     
        }
      })
  }
}

let defaultScrollUp = document.querySelectorAll('.animation-scroll__up-default')
if (defaultScrollUp.length > 0) {
  defaultScrollUp.forEach((element) => {
    const wrap = element.querySelector('.wrap');
    gsap.set(wrap, { yPercent: '20', opacity:0 })
    gsap.to(wrap, {
      yPercent: 0, opacity: 1, duration: 0.75,
      scrollTrigger: {
          trigger: element, 
          start: 'top 90%',
      }})
  })
}
//animation bottom appear scroll

let bottomAppear = document.querySelectorAll('.animation-bottom__appear-scroll');
if (bottomAppear.length > 0) {
  bottomAppear.forEach(element => {
    let animEl = element.querySelector('.animation-el');
    gsap.set(animEl, {
      y : "0%",
    })
    gsap.
      timeline({
        scrollTrigger: {
          trigger: element, 
          start: 'top 70%', 
          end: 'center 70%', 
          toggleActions: 'play none none none', 
          // markers: true,
          // scrub: 1
        }
      })
      .to(animEl, {
        duration: 2,
        y: "-100%",
        ease: "power4.out",
      })
  });
}



// SWIPER CAROUSEL SIMPLE
const swiperElementsSimple = document.querySelectorAll('.carousel__simple')

if(swiperElementsSimple.length > 0){
  swiperElementsSimple.forEach((swiperEl, index) =>{
    const countSlides = swiperEl.querySelectorAll('.swiper-slide');
    if (countSlides <= 3) {
      const arrowDesk = swiperEl.querySelector('.arrow-col');
      const swiperWrap = swiperEl.querySelector('.swiper-col');

      arrowDesk.style.display = 'none';
      swiperWrap.classList.remove('lg:col-span-11');

    }
    
    let swiper = new Swiper(swiperEl.querySelector('.swiper__simple'), {
      slidesPerView: 1,
      spaceBetween: 32,
      breakpoints: {
        0: {
          slidesPerView: 1,
          navigation: {
            nextEl: swiperEl.querySelector(".mobile-arrow-next"),
            prevEl: swiperEl.querySelector(".mobile-arrow-prev"),
          },
        },
        768: {
          slidesPerView: 2,
          navigation: {
            nextEl: swiperEl.querySelector(".mobile-arrow-next"),
            prevEl: swiperEl.querySelector(".mobile-arrow-prev"),
          },
        },
        1024: {
          slidesPerView: 3,
          navigation: {
            nextEl: swiperEl.querySelector(".arrow-next"),
            prevEl: swiperEl.querySelector(".arrow-prev"),
          },
        },
        1440: {
          slidesPerView: 3,
          navigation: {
            nextEl: swiperEl.querySelector(".arrow-next"),
            prevEl: swiperEl.querySelector(".arrow-prev"),
          },
        }
      }
    });
  })
}



// SWIPER CAROUSLE IMAGE
const swiperElementsImage = document.querySelectorAll('.carousel__image')
if(swiperElementsImage.length > 0){
  
  swiperElementsImage.forEach((swiperEl, index) => {
    
    const countSlides = swiperEl.querySelectorAll('.swiper-slide').length;

    if (countSlides <= 3) {
      const arrowDesk = swiperEl.querySelector('.arrow-col');
      const swiperWrap = swiperEl.querySelector('.swiper-col');

      arrowDesk.style.display = 'none';
      swiperWrap.classList.remove('lg:col-span-11');

    }
    

    let swiper = new Swiper(swiperEl.querySelector('.swiper__image'), {
      slidesPerView: 1,
      spaceBetween: 32,
      breakpoints: {
        0: {
          slidesPerView: 1,
          navigation: {
            nextEl: swiperEl.querySelector(".mobile-arrow-next"),
            prevEl: swiperEl.querySelector(".mobile-arrow-prev"),
          },
        },
        768: {
          slidesPerView: 2,
          navigation: {
            nextEl: swiperEl.querySelector(".mobile-arrow-next"),
            prevEl: swiperEl.querySelector(".mobile-arrow-prev"),
          },
        },
        1024: {
          slidesPerView: 3,
          navigation: {
            nextEl: swiperEl.querySelector(".arrow-next"),
            prevEl: swiperEl.querySelector(".arrow-prev"),
          },
        },
        1440: {
          slidesPerView: 3,
          navigation: {
            nextEl: swiperEl.querySelector(".arrow-next"),
            prevEl: swiperEl.querySelector(".arrow-prev"),
          },
        }
      },
      on: {
        slideChange: function () {
          console.log('swiper changed');
        },
      },
    });
  })
}


// MODULE STCKY SCROLL

const stickyScrollers = document.querySelectorAll('.module__sticky-scroll');

if(stickyScrollers.length > 0){
  stickyScrollers.forEach((scroller) => {
    const items = scroller.querySelectorAll('.item')
    
    items.forEach((item) => {
      gsap.set(item,{opacity: 0.35})
      const changeColorTl  =  gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top center",
          end: "center center",
          scrub: 1,
        }
      });
      changeColorTl.to(item, {opacity: 1}, '<')
     
    })
    
  })
}


// MODULE TABS

const moduleTabs = document.querySelectorAll('.module__tabs');

if(moduleTabs.length > 0){
  moduleTabs.forEach((module) => {
    const tabsWrapperScroller = module.querySelector('.tabs-wrap ul');
    const tabs = module.querySelectorAll('.tabs-wrap li');
    const panes = module.querySelectorAll('.panes-wrap li');
    // set first selection on load
    tabs[0].classList.add('selected')
    panes[0].classList.add('selected')
    gsap.set(panes[0],{opacity: 1, pointerEvents: "all", position: 'relative'})

    tabs.forEach((tab,tabIndex) =>{
      tab.addEventListener('click', () => {        
        let tabSelected = module.querySelector('.tabs-wrap li.selected')
        let paneSelected = module.querySelector('.panes-wrap li.selected')
        tabSelected.classList.remove('selected')
        tab.classList.add('selected')
        paneSelected.classList.remove('selected')
        const tl = gsap.timeline()
        tl.set(paneSelected, { position: 'absolute' })
        tl.set(panes[tabIndex],{ position: "relative"})
        tl.to(paneSelected, { opacity: 0, pointerEvents: 'none',  duration: 0.5 })
        
        tl.to(panes[tabIndex], {opacity: 1, pointerEvents: "all", duration: 0.5})
        panes[tabIndex].classList.add('selected')
      })
    })

  })
}

// HERO ARTICLE

let heroArticle = document.querySelector('.hero-article');
if (heroArticle) {
  let copyLink = heroArticle.querySelector('.item-copylink');
  copyLink.addEventListener('click',(event) => {
      event.preventDefault();
      navigator.clipboard.writeText(copyLink.getAttribute('data-link'));
  })
}


// let carousel_simple_static = document.querySelectorAll('.carousel-simple__static');
// if (carousel_simple_static.length > 0) {
//   carousel_simple_static.forEach(carousel => {
    
//     let swiper_carousel_simple_static = new Swiper(carousel, {
//       slidesPerView: 1,
//       spaceBetween: 32,
//       navigation: {
//         nextEl: carousel.parentNode.querySelectorAll(".arrow-next"),
//         prevEl: carousel.parentNode.querySelectorAll(".arrow-prev"),
//       },
//       breakpoints: {
//         0: {
//           slidesPerView: 1
//         },
//         768: {
//           slidesPerView: 1.75
//         },
//         1024: {
//           slidesPerView: 2.35
//         },
//         1440: {
//           slidesPerView: 3.35
//         }
//       }
//     });




//   });
// }

const sectorsList = document.querySelectorAll('.module-sectors-list')

if (sectorsList.length > 0) {
  let prevWidth = 0;
  const bindMouseStatus = (bind) => {
    sectorsList.forEach((list) =>{
      const listItems = list.querySelectorAll('li');
      const hoverImgs = list.querySelectorAll('.hover-imgs div');
      listItems.forEach((item, index) => {
        if (bind) {
          item.addEventListener('mouseenter', (e) => {
            gsap.set(hoverImgs[index], { zIndex: 50 })
            gsap.to(hoverImgs[index], { opacity: 1 })
          })
          item.addEventListener('mouseleave', (e) => {
            gsap.set(hoverImgs[index], { zIndex: 1 })
            gsap.to(hoverImgs[index], { opacity: 0, delay: 0.1 })
          })
        } else {
          item.removeEventListener('mouseenter', this, false)
          item.removeEventListener('mouseleave', this,false)
        }
      })
    })
  }
  const resizeHoverImgs = () => {
    if(window.innerWidth !== prevWidth){
      
      if (prevWidth < 1023 && window.innerWidth > 1023) {
        window.addEventListener('mousemove', (e) => {
          window.mouseX = e.clientX;
          window.mouseY = e.clientY;
          gsap.set('.hover-imgs', { left: e.pageX - window.scrollX, top: e.pageY - window.scrollY })
        })
        bindMouseStatus(true)
      }

      else if (prevWidth > 1023 && window.innerWidth < 1023) { 
        window.removeEventListener('mousemove', this, false)
        bindMouseStatus(false)
      }
      prevWidth = window.innerWidth;
    }
  }
  const handleVisibilityOnScroll = (event) => {
    
    sectorsList.forEach((list) => { 
      
      const hoverImgsArray = list.querySelectorAll('.hover-imgs div');
      const rect = list.getBoundingClientRect();
      const mouseX = window.mouseX || 0; // Posizione X del mouse globale
      const mouseY = window.mouseY || 0; // Posizione Y del mouse globale
      
      // Verifica se il cursore è fuori dai confini
      if (
        mouseY < rect.top ||
        mouseY > rect.bottom
      ) {
        gsap.set(hoverImgsArray, { zIndex: 1 })
        gsap.to(hoverImgsArray, { opacity: 0, delay: 0,duration: 0.25 })
      }
    })
  }
  window.addEventListener('resize', resizeHoverImgs);
  window.addEventListener('scroll', (event) =>  handleVisibilityOnScroll(event))
  resizeHoverImgs();
  handleVisibilityOnScroll();
}


// side composition

const sideCompositionArray = document.querySelectorAll('.side-composition')

if(sideCompositionArray.length > 0){
  sideCompositionArray.forEach((side) => {
    let matchMedia = gsap.matchMedia();

    matchMedia.add("(min-width: 768px)", () => {
      const imagesArray = side.querySelectorAll('.media-content img');
      const articlesArray = side.querySelectorAll('article');
      
      articlesArray.forEach((article,i) => {
        if(i > 0) gsap.set(article,{opacity: 0.35});
        gsap.to(imagesArray[i],
          {
            scrollTrigger:{
              trigger: article,
              start: "top center",
              end: "bottom center",
              scrub: false,
              onEnter:()=>{
                gsap.set(imagesArray[i],{position: "relative",zIndex: 10})
                gsap.to(imagesArray[i],{opacity:1})
                gsap.to(article,{opacity:1})
              },
              onLeave: () => {
                
                if(i < imagesArray.length - 1){
                  gsap.set(imagesArray[i],{position: "absolute",zIndex: 1,top: 0})
                  gsap.to(imagesArray[i],{opacity:0,delay: 0.1})
                  gsap.to(article,{opacity:0.35})
                }
              },
              onEnterBack:()=>{
                gsap.set(imagesArray[i],{position: "relative",zIndex: 10})
                gsap.to(imagesArray[i],{opacity:1})
                gsap.to(article,{opacity:1})
              },
              onLeaveBack: () => {
                if(i > 0){
                  gsap.set(imagesArray[i],{position: "absolute",zIndex: 1,top: 0})
                  gsap.to(imagesArray[i],{opacity:0,delay: 0.1})
                  gsap.to(article,{opacity:0.35})
                }
              }
            }
          }
        )
      })
    })
  })
}


/// HERO SIMPLE PRODUCT RECTANGLE H1 ANIMATION

const titleTagWrapArray = document.querySelectorAll('.title-tag_wrap');

if( titleTagWrapArray.length > 0 ){
  titleTagWrapArray.forEach((titleTagWrap) => {
    const titleTag = titleTagWrap.querySelector('.title-tag');
    
    gsap.to(titleTag, {
      x: 0,
      duration: 0.75,
      ease: 'power1.inOut',
      scrollTrigger:{
        trigger: titleTag,
        start: "top bottom",
        scrub: false
      }
    })
  })
  
}

/// MODULE SIDE SCROLLER 

const moduleSideScrollerArray = document.querySelectorAll('.module-side-scroller')

if(moduleSideScrollerArray.length > 0){
  moduleSideScrollerArray.forEach((module) => {

    const scrollerList = module.querySelector('.sticky-scroller-list');
    const listItems = scrollerList.querySelectorAll('li');
    const scrollItems = module.querySelectorAll('.sticky-scroller-item');

    let matchMedia = gsap.matchMedia();

    // tablet/desktop 
    matchMedia.add("(min-width: 768px)", () => {

      scrollItems.forEach((scroller, index) => {
        
        ScrollTrigger.create({
          trigger: scroller,
          start: "top center",
          end: "bottom center",
          onEnter: () => {
            listItems[index].classList.add('selected')
          },
          onLeave: () => {
            if(index < listItems.length - 1){
              listItems[index].classList.remove('selected')
            }
          },
          onEnterBack: () => {
            listItems[index].classList.add('selected')
          },
          onLeaveBack: () => {
            if(index > 0){
              listItems[index].classList.remove('selected')
            }
          }
        })
      })
      listItems.forEach((item,i) => {
        item.addEventListener('click', () =>{
          const elementTop = scrollItems[i].getBoundingClientRect().top;
          var offsetPosition = elementTop + window.scrollY - 32;
  
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        })
      })
    })

    // smartphone only
    matchMedia.add("(max-width: 767px)", () => {

      gsap.set(listItems,{autoAlpha: 0});
      gsap.set(scrollerList, {opacity: 0, pointerEvents: 'none'});

      scrollItems.forEach((scroller,index) => {
        ScrollTrigger.create({
          trigger: scroller,
          start: "top top",
          end: "bottom top",
          onEnter: () => {
            gsap.to(listItems[index],
              {
                autoAlpha: 1,
                duration: 0.3, 
                
            })
            if(index === 0){
              gsap.to(scrollerList, {opacity: 1})
            }
          },
          onLeave: () => {
            gsap.to(listItems[index],
              {
                autoAlpha: 0,
                duration: 0.3,
                
            })
            if(index >= listItems.length - 1){
              gsap.to(scrollerList, {opacity: 0})
            }
          },
          onEnterBack: () => {
            
            gsap.to(listItems[index],
              {
                autoAlpha: 1,
                duration: 0.3, 
                
            })
            gsap.to(scrollerList, {opacity: 1})
          },
          onLeaveBack: () => {
            gsap.to(listItems[index],
              {
                autoAlpha: 0,
                duration: 0.3,
            })
            if(index <= 0){
              gsap.to(scrollerList, {opacity: 0})
            }
          }
        })
      })
    })
  })
}


// accordion toggle


const accordionsArray = document.querySelectorAll('.accordion-wrap');

if (accordionsArray.length > 0) {
  accordionsArray.forEach((accordion) => {
    const trigger = accordion.querySelector('.accordion-trigger');

    trigger.addEventListener('click', () => {
      accordionsArray.forEach((otherAccordion) => {
        if (otherAccordion !== accordion && otherAccordion.classList.contains('selected')) {
          const otherMask = otherAccordion.querySelector('.accordion-content-mask');
          otherAccordion.classList.remove('selected');
          gsap.to(otherMask, { height: 0 });
        }
      });

      const content = accordion.querySelector('.accordion-content');
      const mask = accordion.querySelector('.accordion-content-mask');
      const isSelected = accordion.classList.contains('selected');

      accordion.classList.toggle('selected');
      gsap.to(mask, {
        height: !isSelected ? content.clientHeight : 0,
        onComplete: () => {
          if (!isSelected) {
            gsap.set(mask, { height: 'auto' });
          }
        },
      });
    });
  });
}


// MODULE STICKY CATEGORY

const moduleStickyCategoryArray = document.querySelectorAll('.module-sticky-categories')

if(moduleStickyCategoryArray.length > 0){
  moduleStickyCategoryArray.forEach((module) => {
    const scrollerItemsArray = module.querySelectorAll('.sticky-scroller-item')
    scrollerItemsArray.forEach((item,i) => {
      if(i > 0){
        gsap.set(item,{opacity: 0.35});

        gsap.to(item,{
          
          scrollTrigger:{
            trigger: item,
            start: "top center",
            end: "bottom center",
            onEnter:() => {
              gsap.to(item,{opacity:1})
            },
            onLeave: () => {
              if(i < scrollerItemsArray.length - 1){
                gsap.to(item,{opacity:0.35})
              }
            },
            onEnterBack:() => {
              gsap.to(item,{opacity:1})
            },
            onLeaveBack: () => {
              if(i > 0){
                gsap.to(item,{opacity:0.35})
              }
            }
          }
        })
      }
      
    })
    
  })
  
}

// section-image-scroll

const sectionImageScrollArray = document.querySelectorAll('.section-image-scroll');

if(sectionImageScrollArray.length > 0){
  sectionImageScrollArray.forEach((imageScroll) =>{
    let matchMedia = gsap.matchMedia();

    matchMedia.add("(max-width: 767px)", () => {
      const image = imageScroll.querySelector('img');
      const wrapper = image.parentNode;      
      image.onload = function() {
        
        gsap.to(image,{
        x: wrapper.clientWidth - image.clientWidth,
        scrollTrigger:{
          trigger: wrapper,
          start: "center center",
          end: "+=100%",
          scrub: true,
          pin: wrapper
        }
      })
      } ; 
      
    })
  })
}

//footer scroll to top
let scrollTop = document.querySelector('.scrolltop')
scrollTop.addEventListener('click', function(e) {
  e.preventDefault();
  window.scrollTo({
      top: 0,
      behavior: 'smooth'
  });
});

//searchform when active 
let searchForms = document.querySelectorAll('.searchform');

if (searchForms) {
  searchForms.forEach(searchForm => {

    let searchFormInput = searchForm.querySelector('input[type="text"]');

    const searchActive = (active) => {
      if (active === true) {
        searchForm.classList.add('active')
      }else {
        searchForm.classList.remove('active')
      }
    }
  
    searchForm.addEventListener('submit', function(e) {
          if (searchFormInput.value.length <= 0) {
            e.preventDefault();
          }
    });
  
    if (searchFormInput.value.length > 0) {
      searchActive(true)
    }
  
    searchFormInput.addEventListener('keyup', ()=> {
      if (searchFormInput.value.length > 0) {
        searchActive(true)
      }
    })
    
  });
}


// FILTER TABS CONTACT

const moduleTabsContact = document.querySelectorAll('.module__tabscontact')

if (moduleTabsContact?.length > 0) {
  moduleTabsContact.forEach((module, index) => {
    const tabsContactFilters = module.querySelectorAll('.filter-country');
    const panesContent = module.querySelectorAll('.panes-wrap li');
    tabsContactFilters.forEach((element, id) => {
      const trigger = element.querySelector('.filter-country-toggle .trigger');
      const selectionTriggers = element.querySelectorAll('.dropdown-list p');
      const current = element.querySelector('.current');
      const defaultText = element.querySelector('.default');
      const deleteFilter = element.querySelector('.delete-filter');
      const allCountryElements = panesContent[id].querySelectorAll(`.countries-single`)

      trigger.addEventListener('click', function () {
        element.classList.toggle('open')
      })
      deleteFilter.addEventListener('click', function () {
        defaultText.classList.remove('hidden')
        current.classList.add('hidden')
        deleteFilter.classList.add('hidden')
        current.innerText = '';
        gsap.set(allCountryElements, { autoAlpha: 1, position: 'relative' })
      })
      selectionTriggers.forEach(selection => {
        
        selection.addEventListener('click', function () {
          element.classList.toggle('open');
          
          const country = this.getAttribute('data-country');
          
          const countryElementsSelected = panesContent[id].querySelectorAll(`.countries-single[data-country="${country}"`)

          defaultText.classList.add('hidden')
          current.classList.remove('hidden')
          deleteFilter.classList.remove('hidden')
          current.innerText = country
            
          gsap.set(allCountryElements, { autoAlpha: 0, position: 'absolute' })
          gsap.set(countryElementsSelected, { autoAlpha: 1, position: 'relative' })
          
        })
        
      })
    })
  })
  
}


// change zoom 


// hero home

const heroHomeWrap = document.querySelector('.hero-home');
if (heroHomeWrap) {
  if (window.matchMedia("(min-width: 1023px)").matches) {
    const heroHomeVideo = document.querySelector('.video-scroll');
    const heroHomeVideoWrap = document.querySelector('.video-scroll__wrap');
    const heroHomeOverlay = document.querySelector('.media');
    gsap.to(heroHomeVideo, {
      width: "100%",
      scrollTrigger: {
        trigger: heroHomeVideoWrap,
        endTrigger: ".spacer-video",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        pin: true,
      }
    });

    gsap.to(heroHomeOverlay, {
      opacity: 0, // Fades out
      scrollTrigger: {
        trigger: '.textwrap',
        start: "20% top",
        end: "center top",
        scrub: true,
        // markers: true
      }
    });
  }
}